// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { DialogSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { s_black_square, s_popup_darkblue_rect, s_popup_top, s_popup_bottom, s_popup_close, s_icon_close, s_btn_green } from "../AssetDefinitions/ImageDefinitions";
import { EventSystem } from "../Events/EventSystem";
import { Events } from "../Events/Events";
tgfSettings.dialogDefaults.ConfirmationDialog = {
    width: 800,
    height: 500,
    headerText: "",
    bodyText: "",
    buttonText: "",
    font: DialogSettings.textFont,
    buttonFont: DialogSettings.buttonFont,
    onAccept: null,
    onDecline: null,
    components: [] // The additional components to add
};
export var ConfirmationDialog = function (properties) {
    "use strict";
    this.name = "ConfirmationDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.ConfirmationDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.onDisconnect = this.close.bind(this, false);
    EventSystem.subscribe(Events.DISCONNECTED, this.onDisconnect);
};
// Inherit the base dialog
tgfDialogs.inherit(ConfirmationDialog, DialogBase);
ConfirmationDialog.prototype.doPrepare = function () {
    "use strict";
    this.transparentBlack = new ComponentButton({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.background = new ComponentPicture({
        image: s_popup_darkblue_rect,
        createFromSlices: true,
        sliceMarginsArray: [55, 55, 55, 55],
        width: this.width,
        height: this.height,
        x: -(this.width / 2),
        y: -(this.height / 2)
    });
    this.transparentBlack.addComponent(this.background);
    this.headerBackground = new ComponentPicture({
        image: s_popup_top,
        x: tgfGraphics.areaWidth / 2,
        y: -this.height / 2 + tgfGraphics.areaHeight / 2
    });
    this.addComponent(this.headerBackground);
    this.addComponent(new ComponentPicture({ image: s_popup_bottom, x: tgfGraphics.areaWidth / 2, y: this.height / 2 - 20 + tgfGraphics.areaHeight / 2 }));
    this.headerLabel = new ComponentLabel({
        text: this.headerText,
        font: this.font,
        y: 4
    });
    this.headerBackground.addComponent(this.headerLabel);
    this.closeButton = new ComponentButton({
        image: s_popup_close,
        icon: s_icon_close,
        x: this.width / 2 + 5,
        y: 33,
        onClick: this._onButtonPress.bind(this, false),
    });
    this.headerBackground.addComponent(this.closeButton);
    this.textBody = new ComponentLabel({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 - 50,
        text: this.bodyText,
        font: this.font,
        width: this.width,
        splitLines: true,
    });
    this.addComponent(this.textBody);
    this.acceptButton = new ComponentButton({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 + this.height * 0.5 - 100,
        image: s_btn_green,
        text: this.buttonText,
        onClick: this._onButtonPress.bind(this, true),
        fontUp: this.buttonFont
    });
    this.addComponent(this.acceptButton);
};
ConfirmationDialog.prototype.close = function (callOnClose) {
    this.hide();
    this.free();
    EventSystem.unsubscribe(Events.DISCONNECTED, this.onDisconnect);
    if (this.onClose && callOnClose) {
        this.onClose();
    }
};
ConfirmationDialog.prototype.toggleInput = function (enable) {
    if (enable) {
        this.activate();
    }
    else {
        this.deactivate();
    }
};
ConfirmationDialog.prototype._onButtonPress = function (accept) {
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    this.close(true);
    if (accept) {
        if (this.onAccept) {
            this.onAccept();
        }
    }
    else {
        if (this.onDecline) {
            this.onDecline();
        }
    }
};
